import {useEffect, useMemo, useState} from 'react';
import {Badge, Button, Col, Image, Row} from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';

import sepidarTeam from '../../images/sepidar-team.jpg'

import {getSortedProjects} from '../../db/projectStore'
import {SponsorLogos} from '../SponsorLogos'

const FeaturedCarousel = ({images}) => {
  if (!images || images.length === 0) return null;
  return (
    <Carousel id='home-slider' fade controls={false} indicators={false} style={{borderRadius: '25px'}}>
      {images.map((image, index) => (
        <Carousel.Item key={index} interval={4000}>
          <img className="d-block w-100" src={image.src} alt={image.alt}/>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export const Home = () => {
  const [carouselImages, setCarouselImages] = useState([]);

  const project = useMemo(() => {
    const projects = getSortedProjects();
    return projects && projects.length > 0 ? projects[0] : null;
  }, []);

  useEffect(() => {
    if (!project) return;
    const load = async () => {
      const images = [];
      if (project.posterImage) {
        try {
          const src = (await import(`../../images/${project.path}/${project.posterImage}`)).default;
          images.push({src, alt: project.title});
        } catch (e) {
          console.error('Error loading home poster image:', e);
        }
      }
      setCarouselImages(images);
    };
    load().catch(e => console.log(e));
  }, [project]);

  if (!project) return null;

  const descriptionParagraphs = Array.isArray(project.description)
    ? project.description
    : (project.description || '').split(/\n+/).filter(Boolean);

  const descriptionFooterParagraphs = Array.isArray(project.descriptionFooter)
    ? project.descriptionFooter
    : (project.descriptionFooter ? [project.descriptionFooter] : []);

  const firstDateGroup = (project.dateGroups || []).find(g => g.items && g.items.length > 0);
  const firstGroupItems = firstDateGroup?.items || [];

  return (
    <div>
      <Row>
        <Col xs={12} lg={7} className="d-flex flex-column justify-content-end mb-5">
          <h1 className='display-1 fw-bold'>{project.title}</h1>
          <p className='fs-3 fw-light' style={{flexGrow: '1'}}>
            {project.caption}
          </p>
          {firstGroupItems.map((item, index) => (
            <div key={index}>
              <h3 className='display-6'><Badge bg="secondary">{item.location}</Badge></h3>
              <h4 className="d-flex align-items-center"><span className='display-6'>{item.date}</span></h4>
            </div>
          ))}
          {project.tickets?.url &&
            <div>
              <Button variant="light" size="lg" href={project.tickets.url} target="_blank" rel="noopener noreferrer">
                Tickets
              </Button>
            </div>
          }
          {project.tickets?.priceInfo &&
            <blockquote className="blockquote mt-1">
              <p></p>
              <footer className="blockquote-footer">
                {project.tickets.priceInfo}
              </footer>
            </blockquote>
          }
        </Col>
        <Col xs={12} lg={5} className="mb-5">
          <FeaturedCarousel images={carouselImages}/>
        </Col>
      </Row>
      <Row>
        {descriptionParagraphs.map((paragraph, index) => (
          <p key={index} className='fs-4 fw-light'>{paragraph}</p>
        ))}
        {descriptionFooterParagraphs.map((paragraph, index) => (
          <p key={`footer-${index}`} className='fs-6 fw-light fst-italic'>{paragraph}</p>
        ))}
      </Row>
      {(project.cast?.length > 0) &&
        <Row>
          <Col xs={12} lg={7} className="mb-5">
            <p className='fs-5 mt-5'>Cast & Credits</p>
            <p className='fs-5 mt-5'>
              {project.cast.map((item, index) => (
                <span key={index} className='d-block'>{item.role}:<strong> {item.names} </strong></span>
              ))}
            </p>
          </Col>
          <Col xs={12} lg={5} className="mb-5">
            <Image src={sepidarTeam} alt='Sepidar Team' fluid />
          </Col>
        </Row>
      }
      <SponsorLogos logos={project.logos} />
    </div>
  )
}


